import { StocksExchangeWalletAction } from './stocks-exchange-wallet.action';
import { createSelector } from '@ngrx/store';
import { UtilitiesService } from '../../services/utilities.service';
import { InitializerAction } from '../initializer/initiliazer.action';
import { StocksExchangeInvestment } from '../../models/exchange/stocks-exchange-investment.model';
import { Strategy } from '../../models/exchange/strategy.model';
import { MessageCode } from '../../enum/message-code/message-code.enum';

export class StocksExchangeWalletState {
    /**
     * Ordens
     */
    public orders: any[];
    public validOrders: any[];
    public ordersArray: any[];
    public order: any;
    public loadingOrder: boolean;
    public loadingOrders: boolean;
    public ordersError: null;
    public orderError: null;
    public ordersSearch: any[];
    public loadingSearch: boolean;
    public strategyError: any;
    /**
     * Estratégias
     */
    public strategies: any[];
    public validStrategies: Strategy[];
    public strategiesSearch: any[];
    /** seleciona uma stratégia */
    public strategy: any;
    public loadingStrategies: boolean;
    public loadingStrategy: boolean;
    public strategiesError: null;
    /** Datas que tiveram negociação */
    public datesPending: boolean;
    public datesError: any;
    public tradingDates: any[];
    /** Datas que tiveram negociação */
    public orderExecutionDatePending: boolean;
    public orderExecutionDateError: any;
    public orderExecutionDate: any[];
    /** Datas que tiveram negociação */
    public strategyExecutionDatePending: boolean;
    public strategyExecutionDateError: any;
    public strategyExecutionDate: any[];
    // lista de investimentos do usuário
    public investments: StocksExchangeInvestment[];
    // carregando investmentos
    public loadingInvestments: boolean;
    // erro de investmentos
    public investmentsError: null;
    public custodieRealtime: any;
    /**
     * Investimentos desatualizados
     */
    public investimentsOutdated: boolean;
}

export const initialState: StocksExchangeWalletState = {
    orders: null,
    validOrders: [],
    ordersArray: [],
    order: null,
    ordersSearch: [],
    strategies: null,
    validStrategies: [],
    strategy: null,
    strategiesSearch: [],
    loadingOrders: false,
    loadingOrder: false,
    loadingStrategy: false,
    loadingSearch: false,
    loadingStrategies: false,
    ordersError: null,
    orderError: null,
    strategiesError: null,
    tradingDates: [],
    orderExecutionDate: [],
    strategyExecutionDate: [],
    datesPending: false,
    datesError: null,
    orderExecutionDatePending: false,
    orderExecutionDateError: null,
    strategyExecutionDatePending: false,
    strategyExecutionDateError: null,
    investments: [],
    loadingInvestments: false,
    investmentsError: null,
    custodieRealtime: null,
    investimentsOutdated: false,
    strategyError: null,
};

export function StocksExchangeWalletReducer(
    state: StocksExchangeWalletState = initialState,
    action?: StocksExchangeWalletAction,
): StocksExchangeWalletState {

    switch (action.type) {
        // busca ordens
        case StocksExchangeWalletAction.getOrders:
            return { ...state, ...{ loadingOrders: true } };
        case StocksExchangeWalletAction.getOrdersError:
            return { ...state, ...{ loadingOrders: false, ordersError: action.payload } };
        case StocksExchangeWalletAction.getOrdersSuccess:
            return { ...state, ...{ loadingOrders: false, orders: UtilitiesService.mergeIndexableObject(state.orders, action.payload, 'id') } };

        case StocksExchangeWalletAction.getValidOrders:
            return { ...state, ...{ loadingOrders: true } };
        case StocksExchangeWalletAction.getValidOrdersError:
            return { ...state, ...{ loadingOrders: false, ordersError: action.payload } };
        case StocksExchangeWalletAction.getValidOrdersSuccess:
            return {
                ...state,
                ...{ loadingOrders: false, validOrders: UtilitiesService.mergeIndexableObject(state.validOrders, action.payload, 'id') } };

        case StocksExchangeWalletAction.getStrategies:
            return { ...state, ...{ loadingStrategies: true } };
        case StocksExchangeWalletAction.getStrategiesError:
            return { ...state, ...{ loadingStrategies: false, strategiesError: action.payload } };
        case StocksExchangeWalletAction.getStrategiesSuccess:
            return {
                ...state,
                ...{
                    loadingStrategies: false,
                    strategies: UtilitiesService.mergeIndexableObject(state.strategies, action.payload, 'strategyID') } };

        case StocksExchangeWalletAction.getValidStrategies:
            return { ...state, ...{ loadingStrategies: true } };
        case StocksExchangeWalletAction.getValidStrategiesError:
            return { ...state, ...{ loadingStrategies: false, strategiesError: action.payload } };
        case StocksExchangeWalletAction.getValidStrategiesSuccess:
            return {
                ...state,
                ...{
                    loadingStrategies: false,
                    validStrategies: UtilitiesService.mergeIndexableObject(state.validStrategies, action.payload, 'strategyID') } };

        case StocksExchangeWalletAction.strategyUpdated:
            return {
                ...state,
                ...{
                    loadingStrategies: false,
                    validStrategies: UtilitiesService.mergeIndexableObject(state.validStrategies, [action.payload], 'strategyID') } };

        case StocksExchangeWalletAction.orderUpdated:
            return {
                ...state,
                ...{ loadingStrategies: false, validOrders: UtilitiesService.mergeIndexableObject(state.validOrders, [action.payload], 'id') } };

        case StocksExchangeWalletAction.getOrder:
            return { ...state, ...{ loadingOrder: true } };
        case StocksExchangeWalletAction.getOrderError:
            return { ...state, ...{ loadingOrder: false, orderError: action.payload } };
        case StocksExchangeWalletAction.getOrderSuccess:
            return { ...state, ...{ loadingOrder: false, order: action.payload } };
        case StocksExchangeWalletAction.resetOrder:
            return { ...state, ...{ loadingOrder: false, order: null } };

        case StocksExchangeWalletAction.getStrategy:
            return { ...state, ...{ loadingStrategy: true } };
        case StocksExchangeWalletAction.getStrategyError:
            return { ...state, ...{ loadingStrategy: false, strategyError: action.payload } };
        case StocksExchangeWalletAction.getStrategySuccess:
            return { ...state, ...{ loadingStrategy: false, strategy: action.payload } };
        case StocksExchangeWalletAction.strategyNotFound:
            return { ...state, ...{ loadingStrategy: false} };
        case StocksExchangeWalletAction.resetStrategy:
            return { ...state, ...{ loadingStrategy: false, strategy: null } };

        case StocksExchangeWalletAction.getTradingDates:
            return { ...state, ...{ datesPending: true } };
        case StocksExchangeWalletAction.getTradingDatesError:
            return { ...state, ...{ datesPending: false, datesError: action.payload } };
        case StocksExchangeWalletAction.getTradingDatesSuccess:
            return { ...state, ...{ datesPending: false, tradingDates: action.payload } };

        case StocksExchangeWalletAction.getOrderExecutionDate:
            return { ...state, ...{ orderExecutionDatePending: true } };
        case StocksExchangeWalletAction.getOrderExecutionDateError:
            return { ...state, ...{ orderExecutionDatePending: false, orderExecutionDateError: action.payload } };
        case StocksExchangeWalletAction.getOrderExecutionDateSuccess:
            return { ...state, ...{ orderExecutionDatePending: false, orderExecutionDate: [...action.payload] } };

        case StocksExchangeWalletAction.getMyHistoricStrategies:
            return { ...state, ...{ loadingSearch: true } };
        case StocksExchangeWalletAction.getMyHistoricStrategiesError:
            return { ...state, ...{ loadingSearch: false, strategiesError: action.payload } };
        case StocksExchangeWalletAction.getMyHistoricStrategiesSuccess:
            return { ...state, ...{ loadingSearch: false, strategiesSearch: [...action.payload] } };

        case StocksExchangeWalletAction.getOrdersSearch:
            return { ...state, ...{ loadingSearch: true } };
        case StocksExchangeWalletAction.getOrdersSearchError:
            return { ...state, ...{ loadingSearch: false, ordersError: action.payload } };
        case StocksExchangeWalletAction.getOrdersSearchSuccess:
            return { ...state, ...{ loadingSearch: false, ordersSearch: [...action.payload] } };

        case StocksExchangeWalletAction.getStretegiesSearch:
            return { ...state, ...{ loadingSearch: true } };
        case StocksExchangeWalletAction.getStretegiesSearchError:
            return { ...state, ...{ loadingSearch: false, strategiesError: action.payload } };
        case StocksExchangeWalletAction.getStretegiesSearchSuccess:
            return { ...state, ...{ loadingSearch: false, strategiesSearch: [...action.payload] } };

        case InitializerAction.resetUserRelatedData:
            return {...state, ...{
                                    orders: initialState.orders,
                                    validOrders: initialState.validOrders,
                                    ordersArray: initialState.ordersArray,
                                    order: initialState.order,
                                    ordersSearch: initialState.ordersSearch,
                                    strategies: initialState.strategies,
                                    validStrategies: initialState.validStrategies,
                                    strategy: initialState.strategy,
                                    strategiesSearch: initialState.strategiesSearch,
                                    tradingDates: initialState.tradingDates,
                                    orderExecutionDate: initialState.orderExecutionDate,
                                    strategyExecutionDate: initialState.strategyExecutionDate,
                                },
                    };

        case StocksExchangeWalletAction.custodyUpdated:
            return {...state, ...{custodieRealtime: action.payload}};

        case StocksExchangeWalletAction.getInvestments:
            return {
                ...state,
                ...{
                    loadingInvestments: true,
                },
            };

        case StocksExchangeWalletAction.getInvestmentsSuccess:
            return {
                ...state,
                ...{
                    loadingInvestments: false,
                    investments: action.payload.investments || action.payload,
                    investmentsError: null,
                    investimentsOutdated: false
                },
            };

        case StocksExchangeWalletAction.getInvestmentsError:
            return {
                    ...state,
                    ...{
                        loadingInvestments: false,
                        investmentsError: action.payload,
                        investimentsOutdated: anyOutdatedWarning(action.payload),
                    },
                };

        default:
            return state;
    }
}
/**
 * Verifica se existe algum aviso de dados desatualizados
 */
function anyOutdatedWarning(messages: Array<{text: string, code: string}>) {
    if (!Array.isArray(messages)) return false;

    return messages.some((message) => message.code === MessageCode.OutdatedInvestiments);
}
